import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import classNames from 'classnames'
import styles from './index.module.scss'
import { providerSearchNumber } from 'constants/common'
import NumberFormat from 'react-number-format'
import { seFriendlyPhoneNumber } from 'app/SeFriendly/constants'
import PhoneNumberLink from 'common/PhoneNumberLink'
import useFooterLinkUrl from '../hooks/useFooterLinkUrl'

type LinkProps = {
  thriveworksLinks: FooterLink[]
  resourcesLinks: FooterLink[]
  servicesLinks: FooterLink[]
  insuranceLinks: FooterLink[]
  isSeFriendly?: boolean
}

const Links: React.FC<LinkProps> = ({
  thriveworksLinks,
  resourcesLinks,
  servicesLinks,
  insuranceLinks,
  isSeFriendly = false,
}) => {
  const enhanceFooterUrl = useFooterLinkUrl()
  const { phoneNumber, formattedPhoneNumber } = providerSearchNumber
  const phoneNumberCTA = isSeFriendly
    ? seFriendlyPhoneNumber.formattedPhoneNumber
    : formattedPhoneNumber

  return (
    <>
      <Row className={`pt-3 ${styles.links_container_desktop}`}>
        <Col className="pl-0">
          <h3 className={styles.links_header}>Thriveworks</h3>
          <ul className="m-0 p-0 list-unstyled">
            {thriveworksLinks.map((data) => (
              <li
                className={`d-flex ${styles.links_items}`}
                key={`${data.link + data.label}`}
              >
                <a target="_blank" rel="noreferrer" href={data.link}>
                  {data.label}
                </a>
                {data.label === 'Careers' && (
                  <div
                    className={`${styles.hiring_badge} rounded-pill ml-2 px-2 py-1 flex-center`}
                  >
                    HIRING
                  </div>
                )}
              </li>
            ))}
          </ul>
          <h3
            className={`${styles.links_header} ${styles.links_header_reach_us}`}
          >
            Reach us
          </h3>
          <ul className="m-0 p-0 list-unstyled">
            <li className={styles.links_items}>
              <PhoneNumberLink
                isNextLink={true}
                href={`tel:${
                  isSeFriendly ? seFriendlyPhoneNumber.phoneNumber : phoneNumber
                }`}
                phoneNumberCTA={phoneNumberCTA}
              >
                <NumberFormat
                  value={phoneNumberCTA}
                  format="(###) ###-####"
                  displayType="text"
                />
              </PhoneNumberLink>
            </li>
            <li className={styles.links_items}>
              <a
                target="_blank"
                rel="noreferrer"
                href={enhanceFooterUrl('/contact-thriveworks/')}
              >
                Contact us
              </a>
            </li>
          </ul>
        </Col>
        <Col className="pl-0">
          <h3 className={styles.links_header}>Resources</h3>
          <ul className="m-0 p-0 list-unstyled row">
            {resourcesLinks.map((data, index) => (
              <li
                className={classNames('p-0 col-lg-12', [styles.links_items], {
                  'pr-3': index % 2 === 0,
                })}
                key={`${data.link + data.label}`}
              >
                <a target="_blank" rel="noreferrer" href={data.link}>
                  {data.label}
                </a>
              </li>
            ))}
          </ul>
        </Col>
        <Col className="pl-0">
          <h3 className={styles.links_header}>Services</h3>
          <ul className="m-0 p-0 list-unstyled row">
            {servicesLinks.map((data, index) => (
              <li
                className={classNames('p-0 col-lg-12', [styles.links_items], {
                  'pr-3': index % 2 === 0,
                })}
                key={`${data.link + data.label}`}
              >
                <a target="_blank" rel="noreferrer" href={data.link}>
                  {data.label}
                </a>
              </li>
            ))}
          </ul>
        </Col>
        <Col className="pl-0">
          <h3 className={styles.links_header}>Insurance we accept</h3>
          <ul className="m-0 p-0 list-unstyled row">
            {insuranceLinks.map((data, index) => (
              <li
                className={classNames(
                  'p-0 col-xs-12 col-lg-12',
                  styles.links_items,
                  {
                    'pr-3': index % 2 === 0,
                  }
                )}
                key={`${data.link + data.label}`}
              >
                <a target="_blank" rel="noreferrer" href={data.link}>
                  {data.label}
                </a>
              </li>
            ))}
            <li
              className={classNames(
                'p-0 col-xs-12 col-lg-12',
                styles.links_items
              )}
            >
              *Varies by location
            </li>
          </ul>
        </Col>
      </Row>
    </>
  )
}

export default Links
